import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-edit',
	path: '/secure/admin/EditFieldLayout!default.jspa',
};
